"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDriverVariableAprWithAnnotation = exports.getDriverVariableApr = exports.getDriverFixedAprWithAnnotation = exports.getDriverFixedApr = exports.getDriverMinCreditScore = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _educationLoans = require("../selectors/education-loans");

var _format = require("../utils/format");

var _drivers = require("../constants/drivers");

/**
 * @module
 *
 * @description Education Loans driver configurations
 */

/**
 * Get the min. credit score driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */
var getDriverMinCreditScore = function getDriverMinCreditScore(offer) {
  return {
    id: 'minCreditScore',
    label: 'Min. credit score',
    value: (0, _educationLoans.getMinFICO)(offer),
    valueSize: _drivers.VALUE_SIZES.MEDIUM
  };
};
/**
 * Get the fixed APR driver with HTML tooltip.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The disclaimer "quick fact" driver.
 */


exports.getDriverMinCreditScore = getDriverMinCreditScore;

var getDriverFixedApr = function getDriverFixedApr(offer) {
  return {
    id: 'fixedAPR',
    label: 'Fixed APR',
    value: (0, _format.getPercentageRange)((0, _educationLoans.getMinFixedAPR)(offer), (0, _educationLoans.getMaxFixedAPR)(offer)),
    valueSize: _drivers.VALUE_SIZES.MEDIUM,
    UNSAFE_valueTooltip: (0, _educationLoans.getDisclaimer)(offer)
  };
};
/**
 * Get the fixed APR driver with annotation tooltip.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The annotation "quick fact" driver.
 */


exports.getDriverFixedApr = getDriverFixedApr;

var getDriverFixedAprWithAnnotation = function getDriverFixedAprWithAnnotation(offer) {
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, getDriverFixedApr(offer)), {}, {
    UNSAFE_valueTooltip: (0, _educationLoans.getFixedAprAnnotation)(offer)
  });
};
/**
 * Get the variable APR driver with HTML tooltip.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The disclaimer "quick fact" driver.
 */


exports.getDriverFixedAprWithAnnotation = getDriverFixedAprWithAnnotation;

var getDriverVariableApr = function getDriverVariableApr(offer) {
  return {
    id: 'variableAPR',
    label: 'Variable APR',
    value: (0, _format.getPercentageRange)((0, _educationLoans.getMinVariableAPR)(offer), (0, _educationLoans.getMaxVariableAPR)(offer)),
    valueSize: _drivers.VALUE_SIZES.MEDIUM,
    UNSAFE_valueTooltip: (0, _educationLoans.getDisclaimer)(offer)
  };
};
/**
 * Get the fixed APR driver with annotation tooltip.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The annotation "quick fact" driver.
 */


exports.getDriverVariableApr = getDriverVariableApr;

var getDriverVariableAprWithAnnotation = function getDriverVariableAprWithAnnotation(offer) {
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, getDriverVariableApr(offer)), {}, {
    UNSAFE_valueTooltip: (0, _educationLoans.getVariableAprAnnotation)(offer)
  });
};

exports.getDriverVariableAprWithAnnotation = getDriverVariableAprWithAnnotation;